import { useState } from 'react';
import { POLICY_PAGES } from '../data/policy.js';
import { POLICY_PAGES_EN } from '../data/policy-en.js';
import { useI18n } from '../lib/i18n.jsx';
import Breadcrumb from '../components/Breadcrumb.jsx';

export default function Policy({ slug, nav }) {
  const { t, lang } = useI18n();
  // EN mode ใช้หน้าแปล — ถ้า slug ไหนไม่มีใน EN (กันพลาด) fallback ไทย
  const pages = lang === 'en' ? POLICY_PAGES_EN : POLICY_PAGES;
  const p = pages.find((x) => x.slug === slug) || POLICY_PAGES.find((x) => x.slug === slug);
  if (!p) {
    return (
      <section className="blk"><div className="wrap" style={{ textAlign: 'center', padding: '60px 0' }}>
        <h2 style={{ textTransform: 'uppercase' }}>{lang === 'en' ? 'Page not found' : 'ไม่พบหน้านี้'}</h2>
        <button className="btn" onClick={() => nav('/')}>{t('conf.home')}</button>
      </div></section>
    );
  }
  return (
    <>
      <Breadcrumb nav={nav} items={[{ label: t('bc.home'), path: '/' }, { label: p.navLabel }]} />
      <section className="blk"><div className="wrap policy">
        <h1>{p.title.split(' | ')[0]}</h1>
        <div className="policy-intro" dangerouslySetInnerHTML={{ __html: p.intro }} />
        {p.sections.map((s, i) => (
          <div className="policy-sec" key={i}>
            <h2>{s.heading}</h2>
            <div dangerouslySetInnerHTML={{ __html: s.body_html }} />
          </div>
        ))}
        {p.faqs.length > 0 && <FaqList faqs={p.faqs} />}
        <div className="policy-help">
          <span>{lang === 'en' ? 'More questions? Contact ' : 'มีคำถามเพิ่มเติม? ติดต่อ '}<b>contact@barebones.co.th</b></span>
          <div className="policy-links">
            {pages.filter((x) => x.slug !== slug).map((x) => (
              <a key={x.slug} href={`/help/${x.slug}`} onClick={(e) => { e.preventDefault(); nav(`/help/${x.slug}`); }}>{x.navLabel}</a>
            ))}
          </div>
        </div>
      </div></section>
    </>
  );
}

function FaqList({ faqs }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="faq">
      {faqs.map((f, i) => (
        <div className={`faq-item${open === i ? ' open' : ''}`} key={i}>
          <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i}>
            <span>{f.q}</span><span className="faq-ico">{open === i ? '−' : '+'}</span>
          </button>
          {open === i && <div className="faq-a">{f.a}</div>}
        </div>
      ))}
    </div>
  );
}
